<template>
  <a :href="href" class="download-link" target="_blank">
    {{label}}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10.49 9.79"
      class="download-link__icon"
    >
      <path
        fill-rule="evenodd"
        fill="currentColor"
        d="M8.26,3.55a.49.49,0,0,0-.68,0l-1.86,2V.48a.48.48,0,1,0-1,0V5.55l-1.87-2a.49.49,0,0,0-.68,0,.47.47,0,0,0,0,.67L4.9,7.08a.51.51,0,0,0,.35.15h0a.49.49,0,0,0,.34-.15L8.28,4.22A.47.47,0,0,0,8.26,3.55Z"
      />
      <path
        fill-rule="evenodd"
        fill="currentColor"
        d="M10,9.79H.48a.48.48,0,1,1,0-.95H10a.48.48,0,0,1,0,.95Z"
      />
    </svg>
  </a>
</template>

<script>
export default {
  data() {
    return {
      href: ""
    };
  },
  props: {
    file: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if (this.file) {
      this.href = this.file.data.full_url;
    }
  }
};
</script>
